import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class CargoService extends CRUDService{
    constructor() {
        super("cargo");
    }

    listSemGDV(empresaGloboId) {
        return http.get("/"+this.serviceName+"/cargosemgdv/"+empresaGloboId)
    }

    getDetalhesByEmpresaGlobo(cargoId, cargoNome, empresaGloboId) {
        return http.get("/" + this.serviceName + "/detalhar/" + cargoId + "/" + encodeURIComponent(cargoNome) + "/" + empresaGloboId)
    }

    getDetalhesBySolicitacaoId(solicitacaoId) {
        return http.get("/"+this.serviceName+"/detalhar/solicitacao/"+solicitacaoId+"/cargo")
    }

    getByPrefixo(prefixo) {
        return http.get("/"+this.serviceName + "?prefixoCargo=" + encodeURIComponent(prefixo));
    }

    listFromBase() {
        return http.get(`/${this.serviceName}/base`);
    }

    listByPrefixoNome(nome) {
        return http.get(`/${this.serviceName}/prefixo/${encodeURIComponent(nome)}`);
    }

    listCargosHcmByPrefixoNome(nome) {
        return http.get(`/${this.serviceName}/cargos-hcm/${encodeURIComponent(nome)}`);
    }
}
